import {
  registerBegin,
  registerUserSuccessful,
  registerUserFailed,
  resetRegisterFlagChange,
  apiErrorChange,
} from "./reducer";
import { loginSuccess } from "../login/reducer";
import { APIClient, setAuthorization } from "../../../helpers/api_helper";
import * as url from "../../../helpers/url_helper";

const api = new APIClient();

/**
 * Registro: solo usuario (verifying); luego código → workspace con bootstrapFirstWorkspace.
 */
export const registerUser = (payload) => async (dispatch) => {
  try {
    dispatch(registerBegin());
    const body = {
      name: payload.name,
      email: payload.email,
      password: payload.password,
      password_confirmation: payload.password_confirmation,
    };
    const response = await api.create(url.POST_KRONALY_REGISTER, body);
    const inner = response?.data ?? response;
    const reg = inner?.data ?? inner;
    dispatch(registerUserSuccessful(reg));
    if (typeof payload.email === "string") {
      sessionStorage.setItem("kronaly_register_email", payload.email.trim());
    }
    return reg;
  } catch (error) {
    const msg =
      typeof error === "string"
        ? error
        : error?.message || "No se pudo completar el registro";
    dispatch(registerUserFailed(msg));
    throw error;
  }
};

/**
 * Reenvía código de verificación (no toca loading global del registro).
 */
export const resendRegistrationVerificationCode = (email) => async () => {
  const response = await api.create(
    url.POST_KRONALY_RESEND_REGISTRATION_VERIFICATION,
    { email }
  );
  const inner = response?.data ?? response;
  const data = inner?.data ?? inner;
  return {
    message: data?.message || "Solicitud procesada.",
    verification_expires_at: data?.verification_expires_at ?? null,
  };
};

export const verifyRegistration =
  ({ email, code }, history) =>
  async (dispatch) => {
    try {
      dispatch(registerBegin());
      const response = await api.create(url.POST_KRONALY_VERIFY_REGISTRATION, {
        email,
        code,
      });
      const inner = response?.data ?? response;
      const tok = inner?.data ?? inner;
      const access_token = tok?.access_token;

      if (access_token) {
        const userData = { access_token };
        localStorage.setItem("authUser", JSON.stringify(userData));
        setAuthorization(access_token);
        dispatch(loginSuccess(userData));
        localStorage.removeItem("kronaly_workspace_id");
        sessionStorage.removeItem("kronaly_register_email");
        dispatch(registerUserSuccessful(tok));
        // Si el registro vino disparado por una invitación, hay un
        // `next` guardado en sessionStorage — vamos directo allí en
        // lugar de pasar por /register-workspace (el invitado no crea
        // workspace, se une a uno existente).
        const next = sessionStorage.getItem("kronaly_post_auth_next");
        if (history) {
          if (next && next.startsWith("/") && !next.startsWith("//")) {
            sessionStorage.removeItem("kronaly_post_auth_next");
            history(next);
          } else {
            history("/register-workspace");
          }
        }
        return tok;
      }
      dispatch(registerUserFailed("Respuesta inválida del servidor"));
    } catch (error) {
      const msg =
        typeof error === "string"
          ? error
          : error?.message || "Código incorrecto o expirado";
      dispatch(registerUserFailed(msg));
      throw error;
    }
  };

/** Primer workspace tras verificar correo (equivalente a registrar empresa en legacy). */
export const bootstrapFirstWorkspace = (payload, history) => async (dispatch) => {
  try {
    dispatch(registerBegin());
    const response = await api.create(url.POST_WORKSPACES, {
      name: payload.name,
      country: payload.country,
      timezone: payload.timezone,
    });
    const inner = response?.data ?? response;
    const ws = inner?.data ?? inner;
    if (ws?.id) {
      localStorage.setItem("kronaly_workspace_id", ws.id);
    }
    dispatch(registerUserSuccessful(ws));
    dispatch(resetRegisterFlagChange());
    if (history) history("/resumen");
    return ws;
  } catch (error) {
    const msg =
      typeof error === "string"
        ? error
        : error?.message || "No se pudo crear el workspace";
    dispatch(registerUserFailed(msg));
    throw error;
  }
};

export const resetRegisterFlag = () => resetRegisterFlagChange();

/** Acción sincrónica para limpiar flag de error (usa el mismo nombre que el template). */
export const apiError = (payload) => apiErrorChange(payload);
